<template>
  <div class="product-details">
    <a-card>
      <div class="fundSeries">
        <div class="fund-info">
          <div>
            <img src="@/assets/image (2).jpg" alt="" />
            <span>{{ details.fundName }}</span>
          </div>
          <!-- <div>
            <img src="@/assets/image.jpg" alt="" />
            <span>开放期</span>
          </div>
          <div>
            <img src="@/assets/image (1).jpg" alt="" />
            <span>管理期限</span>
          </div> -->
        </div>
        <!-- <a-button style="btn" type="primary" @click="goBack()">返回</a-button> -->
      </div>
      <div class="scale">
        <div class="cost">
          <p>最新规模</p>
          <p>0.00</p>
        </div>
        <div class="cost">
          <p>总手续费(元)</p>
          <p>0.00</p>
        </div>
        <div class="cost">
          <p>管理费(元)</p>
          <p>0.00</p>
        </div>
        <div class="cost">
          <p>业绩报酬(元)</p>
          <p>0.00</p>
        </div>
      </div>

      <div class="relevant_information">
        <a-tabs :default-active-key="tabIndex">
          <a-tab-pane key="1" tab="费率结构">
            <rateManagement ref="constructionShow"></rateManagement>
          </a-tab-pane>
          <a-tab-pane key="2" tab="产品报价" v-if="details.isExpectedPro == 1">
            <productMake ref="productMake"></productMake>
          </a-tab-pane>
          <a-tab-pane key="3" tab="投资经理">
            <investmentManager></investmentManager>
          </a-tab-pane>
          <a-tab-pane key="4" tab="销售网点">
            <commercialNetWorks ref="netWork"></commercialNetWorks>
          </a-tab-pane>
          <a-tab-pane key="5" tab="产品附件">
            <productAccessory ref="productAccessory"></productAccessory>
          </a-tab-pane>
          <a-tab-pane key="6" tab="产品公告">
            <offerQuate></offerQuate>
          </a-tab-pane>
          <a-tab-pane key="7" tab="净值发布规律">
            <publishRules></publishRules>
          </a-tab-pane>
          <a-tab-pane key="8" tab="详细资料">
            <meansDetails></meansDetails>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </div>
</template>
<script>
import { getAction, postAction } from '@/api/manage';
import productAccessory from './modules/productAccessory.vue'; //产品附件
import productMake from './modules/productMake.vue'; //产品报价
import commercialNetWorks from './modules/commercialNetWorks.vue'; //销售网点
import offerQuate from './modules/offerQuate.vue'; //产品资讯
import rateManagement from './modules/rateManagement.vue';
import investmentManager from './modules/investmentManager.vue';
import publishRules from './modules/publishRules.vue';
import meansDetails from './modules/meansDetails.vue';

export default {
  data() {
    return {
      tabIndex: '1',
      details: {},
      url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/find/code'
    };
  },
  components: {
    productAccessory,
    rateManagement,
    productMake,
    commercialNetWorks,
    offerQuate,
    investmentManager,
    publishRules,
    meansDetails
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    goBack() {
      this.$emit('producetStatus', false);
    },
    getDetails() {
      postAction(this.url, { fundCode: this.$route.query.fundCode }).then(
        res => {
          if (res.success) {
            this.details = res.result ? res.result : {};
            if (JSON.stringify(this.details) != '{}') {
              sessionStorage.setItem(
                'productParticulars',
                JSON.stringify(this.details)
              );
            }
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.product-details {
  width: 100%;
  .fundSeries {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .fund-info {
      width: 80%;
      height: 45px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-bottom: 20px;
      div {
        display: flex;
        align-items: center;
        margin-right: 100px;
        font-size: 14px;
        span {
          padding-left: 20px;
        }
      }
    }
  }
  .scale {
    display: flex;
    background: #fff;
    .cost {
      display: flex;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      width: 260px;
      p {
        font-size: 14px;
        &:nth-child(2n) {
          font-size: 22px;
          color: #f69a00;
        }
      }
    }
  }
}
</style>
